import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=163f32f1&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=163f32f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f32f1",
  null
  
)

export default component.exports